import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import "./styles.css";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  doc,
  onSnapshot,
  setDoc,
  collection,
  query,
  onSnapshot as onSnapshotCol,
  addDoc,
  deleteDoc,
  orderBy,
  limit,
  where,
  getDocs,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";
import PainelGestao from "./PainelGestao";
import EscalaLimpeza from "./EscalaLimpeza";
import PainelMovimentos from "./PainelMovimentos";
import HistoricoEdicoes from "./HistoricoEdicoes";

const firebaseConfig = {
  apiKey: "AIzaSyC5gkMN302Mygu4LYFd4hFSZ3Y8wrgADY8",
  authDomain: "coolivin-estadias-ops.firebaseapp.com",
  projectId: "coolivin-estadias-ops",
  storageBucket: "coolivin-estadias-ops.firebasestorage.app",
  messagingSenderId: "337540873115",
  appId: "1:337540873115:web:abf7e82687d0700493ff3e",
  measurementId: "G-QY6F7MCHNH",
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

const BASE_URL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vRrPzKj7MadulbqN-4HqwDJPPfskryKJnspUJJUuP-3Q30L46qhooVgXI6YwEeFkVr0NNYr_R3YTcPk/pub?single=true&output=csv";

const ABAS = [
  { nome: "Carcavelos 1#", gid: "1189011366" },
  { nome: "Saldanha 3#", gid: "1864564737" },
  { nome: "Saldanha 4#", gid: "240104439" },
  { nome: "Saldanha 5#", gid: "547233075" },
  { nome: "Príncipe Real 6#", gid: "809225389" },
  { nome: "Marquês de Pombal 7#", gid: "1857316560" },
  { nome: "Telheiras 8#", gid: "792816498" },
  { nome: "Saldanha 9#", gid: "946044885" },
  { nome: "Saldanha 10#", gid: "111066511" },
  { nome: "Príncipe Real 11#", gid: "104414105" },
  { nome: "Príncipe Real 12#", gid: "1467974413" },
];

function parseRobustCSV(text) {
  const result = [];
  let row = [""];
  let inQuotes = false;
  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    const nextChar = text[i + 1];
    if (char === '"') {
      if (inQuotes && nextChar === '"') {
        row[row.length - 1] += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === "," && !inQuotes) row.push("");
    else if ((char === "\r" || char === "\n") && !inQuotes) {
      if (char === "\r" && nextChar === "\n") i++;
      result.push(row);
      row = [""];
    } else row[row.length - 1] += char;
  }
  if (row.length > 1 || row[0] !== "") result.push(row);
  return result;
}

export default function App() {
  const [dadosGlobais, setDadosGlobais] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sincronizando, setSincronizando] = useState(false);
  const [erro, setErro] = useState(null);
  const [ultimaAtualizacao, setUltimaAtualizacao] = useState(null);
  const [abaAtiva, setAbaAtiva] = useState("limpezas");

  const [notasLimpeza, setNotasLimpeza] = useState({});
  const [prioridades, setPrioridades] = useState({});
  const [tipoCheckout, setTipoCheckout] = useState({});
  const [numInquilinos, setNumInquilinos] = useState({});
  const [tipoQuarto, setTipoQuarto] = useState({});
  const [tipoPreparacao, setTipoPreparacao] = useState({});
  const [limpezasExtra, setLimpezasExtra] = useState([]);
  const [dataLimiteCheckin, setDataLimiteCheckin] = useState("");
  const [reportsOlympus, setReportsOlympus] = useState({});
  const [precosMatriz, setPrecosMatriz] = useState({
    "Simples_Checkout Semestre": 25,
    "Simples_Checkout Airbnb": 30,
    "Suite_Checkout Semestre": 35,
    "Suite_Checkout Airbnb": 40,
  });
  const [configAreasComuns, setConfigAreasComuns] = useState({
    S3: { dias: ["Segunda", "Quinta"], custoMensal: 230 },
    S4: { dias: ["Segunda", "Quinta"], custoMensal: 215 },
    S5: { dias: ["Segunda", "Quinta"], custoMensal: 200 },
    PR6: { dias: ["Segunda", "Quinta"], custoMensal: 205 },
    MP7: { dias: ["Segunda", "Quinta"], custoMensal: 220 },
    S9: { dias: ["Segunda", "Quinta"], custoMensal: 220 },
    S10: { dias: ["Terça", "Sexta"], custoMensal: 260 },
    PR11: { dias: ["Terça", "Sexta"], custoMensal: 200 },
    PR12: { dias: ["Terça", "Sexta"], custoMensal: 200 },
  });
  const [limpezasOcultas, setLimpezasOcultas] = useState([]);
  const [mensagemCarregamento, setMensagemCarregamento] = useState(
    "A preparar as operações Coolivin... Bom trabalho! 🚀"
  );
  const [historicoEdicoes, setHistoricoEdicoes] = useState([]);
  const [senhaHistorico, setSenhaHistorico] = useState("");

  // Só mostramos a app depois de TODAS as configurações "leves" vindas da
  // Firestore (notas, prioridades, tipo_checkout, etc.) terem chegado pelo
  // menos uma vez. Sem isto, a tabela podia desenhar-se com estes valores
  // ainda vazios (ex: uma limpeza marcada como "Urgente" a aparecer como
  // "Normal" por um instante logo a seguir a um recarregamento da página).
  // Propositadamente NÃO incluímos aqui os "olympus_docs" (reports com
  // fotos, que já passam dos 20MB no total) nem "limpezas_extra": esses
  // continuam a carregar em segundo plano, sem bloquear o ecrã inicial.
  const [firestoreConfigCarregado, setFirestoreConfigCarregado] =
    useState(false);
  const listenersCarregadosRef = useRef(new Set());
  const TOTAL_LISTENERS_CONFIG = 10;
  const marcarListenerCarregado = (chave) => {
    listenersCarregadosRef.current.add(chave);
    if (listenersCarregadosRef.current.size >= TOTAL_LISTENERS_CONFIG) {
      setFirestoreConfigCarregado(true);
    }
  };

  // Reports Olympus (olympus_docs) só carregam por defeito dos últimos ~4
  // meses para hoje — a coleção só cresce com o tempo (264 documentos,
  // ~2.75MB à data desta alteração) e descarregá-la sempre por inteiro
  // tornava a app cada vez mais lenta a abrir. Reports mais antigos podem
  // ser trazidos à parte com carregarReportsAntigos, quando for preciso
  // reconciliar um período mais recuado no Report Financeiro.
  const JANELA_REPORTS_DIAS = 120;
  const dataCorteReports = useMemo(() => {
    const d = new Date();
    d.setDate(d.getDate() - JANELA_REPORTS_DIAS);
    return d.toISOString().split("T")[0];
  }, []);
  const [historicoAntigoCarregado, setHistoricoAntigoCarregado] =
    useState(false);

  const isAdmin = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("role") === "admin";
  }, []);

  useEffect(() => {
    if (isAdmin) setAbaAtiva("gestao");
  }, [isAdmin]);

  useEffect(() => {
    onSnapshot(doc(db, "limpezas_config", "notas"), (docSnap) => {
      if (docSnap.exists()) setNotasLimpeza(docSnap.data());
      marcarListenerCarregado("notas");
    });
    onSnapshot(doc(db, "limpezas_config", "prioridades"), (docSnap) => {
      if (docSnap.exists()) setPrioridades(docSnap.data());
      marcarListenerCarregado("prioridades");
    });
    onSnapshot(doc(db, "limpezas_config", "tipo_checkout"), (docSnap) => {
      if (docSnap.exists()) setTipoCheckout(docSnap.data());
      marcarListenerCarregado("tipo_checkout");
    });
    onSnapshot(doc(db, "limpezas_config", "num_inquilinos"), (docSnap) => {
      if (docSnap.exists()) setNumInquilinos(docSnap.data());
      marcarListenerCarregado("num_inquilinos");
    });
    onSnapshot(doc(db, "limpezas_config", "tipo_quarto"), (docSnap) => {
      if (docSnap.exists()) setTipoQuarto(docSnap.data());
      marcarListenerCarregado("tipo_quarto");
    });
    onSnapshot(doc(db, "limpezas_config", "tipo_preparacao"), (docSnap) => {
      if (docSnap.exists()) setTipoPreparacao(docSnap.data());
      marcarListenerCarregado("tipo_preparacao");
    });
    onSnapshot(doc(db, "app_config", "filtro_data"), (docSnap) => {
      if (docSnap.exists() && docSnap.data().dataLimite)
        setDataLimiteCheckin(docSnap.data().dataLimite);
      marcarListenerCarregado("filtro_data");
    });
    // Propositadamente sem marcarListenerCarregado: precisa de poder chegar
    // a tempo de aparecer já no próprio ecrã de carregamento.
    onSnapshot(doc(db, "app_config", "mensagem_carregamento"), (docSnap) => {
      if (docSnap.exists() && docSnap.data().texto)
        setMensagemCarregamento(docSnap.data().texto);
    });
    onSnapshot(doc(db, "limpezas_config", "precos_matriz"), (docSnap) => {
      // merge (não substitui) por cima dos valores por defeito, para uma
      // primeira gravação parcial nunca apagar as combinações que ainda
      // não foram guardadas na cloud
      if (docSnap.exists())
        setPrecosMatriz((prev) => ({ ...prev, ...docSnap.data() }));
      marcarListenerCarregado("precos_matriz");
    });
    onSnapshot(doc(db, "limpezas_config", "areas_comuns"), (docSnap) => {
      if (docSnap.exists())
        setConfigAreasComuns((prev) => ({ ...prev, ...docSnap.data() }));
      marcarListenerCarregado("areas_comuns");
    });
    onSnapshot(doc(db, "limpezas_config", "limpezas_ocultas"), (docSnap) => {
      if (docSnap.exists() && docSnap.data().ids)
        setLimpezasOcultas(docSnap.data().ids);
      marcarListenerCarregado("limpezas_ocultas");
    });

    const qReports = query(
      collection(db, "olympus_docs"),
      where("dataLimpeza", ">=", dataCorteReports)
    );
    const unsubReports = onSnapshotCol(qReports, (snapshot) => {
      const mapa = {};
      snapshot.forEach((doc) => {
        mapa[doc.id] = doc.data();
      });
      // merge, não substitui: preserva reports mais antigos trazidos à
      // parte via carregarReportsAntigos
      setReportsOlympus((prev) => ({ ...prev, ...mapa }));
    });

    const qExtra = query(collection(db, "limpezas_extra"));
    const unsubExtra = onSnapshotCol(qExtra, (querySnapshot) => {
      const extraArr = [];
      querySnapshot.forEach((doc) => {
        extraArr.push({ idCol: doc.id, ...doc.data() });
      });
      setLimpezasExtra(extraArr);
    });

    return () => {
      unsubReports();
      unsubExtra();
    };
  }, []);

  // Escape hatch manual para reconciliar um período mais recuado no Report
  // Financeiro: traz de uma vez só todos os reports anteriores à janela dos
  // últimos ~4 meses e junta-os ao que já está carregado (nunca substitui).
  const [aCarregarReportsAntigos, setACarregarReportsAntigos] =
    useState(false);
  const carregarReportsAntigos = useCallback(async () => {
    if (historicoAntigoCarregado || aCarregarReportsAntigos) return;
    setACarregarReportsAntigos(true);
    try {
      const snapshot = await getDocs(
        query(
          collection(db, "olympus_docs"),
          where("dataLimpeza", "<", dataCorteReports)
        )
      );
      const mapa = {};
      snapshot.forEach((doc) => {
        mapa[doc.id] = doc.data();
      });
      setReportsOlympus((prev) => ({ ...prev, ...mapa }));
      setHistoricoAntigoCarregado(true);
    } catch (err) {
      console.error("Erro ao carregar reports antigos:", err);
    } finally {
      setACarregarReportsAntigos(false);
    }
  }, [historicoAntigoCarregado, aCarregarReportsAntigos, dataCorteReports]);

  // O histórico de edições só é lido quando a pessoa entra mesmo nessa aba —
  // não há motivo para manter mais uma ligação em tempo real aberta desde o
  // arranque da app para uma área que a maior parte das visitas nem chega a
  // abrir.
  useEffect(() => {
    if (abaAtiva !== "historico") return;
    const qHistorico = query(
      collection(db, "historico_edicoes"),
      orderBy("timestamp", "desc"),
      limit(500)
    );
    const unsubHistorico = onSnapshotCol(qHistorico, (snapshot) => {
      setHistoricoEdicoes(
        snapshot.docs.map((d) => ({ id: d.id, ...d.data() }))
      );
    });
    const unsubSenha = onSnapshot(
      doc(db, "app_config", "historico_senha"),
      (docSnap) => {
        if (docSnap.exists() && docSnap.data().senha)
          setSenhaHistorico(docSnap.data().senha);
      }
    );
    return () => {
      unsubHistorico();
      unsubSenha();
    };
  }, [abaAtiva]);

  // Regista uma edição manual da equipa no histórico (área "Histórico de
  // Edições", só visível para admin). Não bloqueia nem falha a gravação
  // principal se o registo em si falhar — é um extra, não o essencial.
  const registrarEdicaoNoHistorico = (tipo, contexto, valorAnterior, valorNovo) => {
    addDoc(collection(db, "historico_edicoes"), {
      tipo,
      contexto: contexto ?? "",
      valorAnterior: valorAnterior === undefined ? null : valorAnterior,
      valorNovo: valorNovo === undefined ? null : valorNovo,
      timestamp: Date.now(),
    }).catch((err) => console.error("Erro ao registar no histórico:", err));
  };

  const salvarNotaNaCloud = async (idChave, valor) => {
    registrarEdicaoNoHistorico(
      "Notas de Equipa Coolivin",
      idChave,
      notasLimpeza[idChave],
      valor
    );
    await setDoc(
      doc(db, "limpezas_config", "notas"),
      { [idChave]: valor },
      { merge: true }
    );
  };
  const togglePrioridadeNaCloud = async (idChave) => {
    const novoValor = !prioridades[idChave];
    registrarEdicaoNoHistorico(
      "Urgente",
      idChave,
      prioridades[idChave] || false,
      novoValor
    );
    await setDoc(
      doc(db, "limpezas_config", "prioridades"),
      { [idChave]: novoValor },
      { merge: true }
    );
  };
  const salvarTipoCheckoutNaCloud = async (idChave, valor) => {
    registrarEdicaoNoHistorico(
      "Tipo de Limpeza",
      idChave,
      tipoCheckout[idChave],
      valor
    );
    await setDoc(
      doc(db, "limpezas_config", "tipo_checkout"),
      { [idChave]: valor },
      { merge: true }
    );
  };
  const salvarNumInquilinosNaCloud = async (idChave, valor) => {
    registrarEdicaoNoHistorico(
      "Nº Inquilinos",
      idChave,
      numInquilinos[idChave],
      valor
    );
    await setDoc(
      doc(db, "limpezas_config", "num_inquilinos"),
      { [idChave]: valor },
      { merge: true }
    );
  };
  const salvarTipoQuartoNaCloud = async (idChave, valor) => {
    registrarEdicaoNoHistorico(
      "Tipo de Quarto",
      idChave,
      tipoQuarto[idChave],
      valor
    );
    await setDoc(
      doc(db, "limpezas_config", "tipo_quarto"),
      { [idChave]: valor },
      { merge: true }
    );
  };
  const salvarTipoPreparacaoNaCloud = async (idChave, valor) => {
    registrarEdicaoNoHistorico(
      "Tipo Preparação",
      idChave,
      tipoPreparacao[idChave],
      valor
    );
    await setDoc(
      doc(db, "limpezas_config", "tipo_preparacao"),
      { [idChave]: valor },
      { merge: true }
    );
  };
  const salvarDataLimiteNaCloud = async (novaData) => {
    registrarEdicaoNoHistorico(
      "Filtro de Histórico Global",
      "app_config",
      dataLimiteCheckin,
      novaData
    );
    await setDoc(doc(db, "app_config", "filtro_data"), {
      dataLimite: novaData,
    });
    setDataLimiteCheckin(novaData);
  };
  const salvarMensagemCarregamentoNaCloud = async (novoTexto) => {
    registrarEdicaoNoHistorico(
      "Frase do Ecrã de Arranque",
      "app_config",
      mensagemCarregamento,
      novoTexto
    );
    await setDoc(doc(db, "app_config", "mensagem_carregamento"), {
      texto: novoTexto,
    });
    setMensagemCarregamento(novoTexto);
  };
  const adicionarLimpezaExtraNaCloud = async (novaLimpeza) => {
    // Pega no idCol ou id gerado, ou usa Date.now() como fallback
    const docId = String(novaLimpeza.idCol || novaLimpeza.id || Date.now());
    registrarEdicaoNoHistorico(
      "Limpeza Extra Criada",
      `${novaLimpeza.apt || ""} · Quarto ${novaLimpeza.quarto || ""}`,
      null,
      novaLimpeza.nome || novaLimpeza.tipoLimpeza || "Limpeza manual"
    );
    await setDoc(doc(db, "limpezas_extra", docId), novaLimpeza);
  };

  const removerLimpezaExtraNaCloud = async (idDocumento) => {
    if (!idDocumento) return;
    registrarEdicaoNoHistorico(
      "Limpeza Extra Removida",
      String(idDocumento),
      null,
      null
    );
    await deleteDoc(doc(db, "limpezas_extra", String(idDocumento)));
  };
  // Último recurso quando não nos passam a data explicitamente: os idChave
  // de limpezas normais e de áreas comuns terminam sempre em AAAA-MM-DD.
  // Não funciona para limpezas extra manuais (idChave tipo "EXTRA_123"),
  // por isso a data deve vir sempre explícita quando possível.
  const extrairDataDeIdChave = (idChave) => {
    const match = String(idChave || "").match(/(\d{4}-\d{2}-\d{2})$/);
    return match ? match[1] : null;
  };

  const salvarReportOlympusNaCloud = async (
    idChave,
    payloadCompleto,
    dataLimpeza
  ) => {
    // Precisamos de um campo de data real (não só embutida no texto do
    // idChave) para conseguirmos pedir à Firestore só os reports de um
    // período, em vez de descarregar sempre a coleção toda — o valor já
    // vindo em payloadCompleto.dataLimpeza (de uma gravação anterior deste
    // mesmo report) tem sempre prioridade, para nunca o perder.
    const dataFinal =
      payloadCompleto.dataLimpeza || dataLimpeza || extrairDataDeIdChave(idChave);
    await setDoc(doc(db, "olympus_docs", idChave), {
      ...payloadCompleto,
      dataLimpeza: dataFinal || null,
    });
  };
  const salvarObservacaoInternaNaCloud = async (idChave, texto) => {
    registrarEdicaoNoHistorico(
      "Observação Interna",
      idChave,
      reportsOlympus[idChave]?.observacaoInterna,
      texto
    );
    await setDoc(
      doc(db, "olympus_docs", idChave),
      { observacaoInterna: texto },
      { merge: true }
    );
  };
  const salvarDataFaturaNaCloud = async (idChave, valor) => {
    registrarEdicaoNoHistorico(
      "Data Fatura",
      idChave,
      reportsOlympus[idChave]?.dataFatura,
      valor
    );
    await setDoc(
      doc(db, "olympus_docs", idChave),
      { dataFatura: valor },
      { merge: true }
    );
  };
  const salvarPrecoBaseManualNaCloud = async (idChave, valor) => {
    registrarEdicaoNoHistorico(
      "Preço Base Manual",
      idChave,
      reportsOlympus[idChave]?.precoBaseManual,
      valor
    );
    await setDoc(
      doc(db, "olympus_docs", idChave),
      { precoBaseManual: valor },
      { merge: true }
    );
  };
  const salvarPrecoMatrizNaCloud = async (chave, valor) => {
    registrarEdicaoNoHistorico(
      "Preço Fixo Matriz",
      chave,
      precosMatriz[chave],
      valor
    );
    await setDoc(
      doc(db, "limpezas_config", "precos_matriz"),
      { [chave]: valor },
      { merge: true }
    );
  };
  const salvarConfigAreaComumNaCloud = async (aptKey, novoObjApt) => {
    const anterior = configAreasComuns[aptKey];
    registrarEdicaoNoHistorico(
      "Configuração Área Comum",
      aptKey,
      anterior
        ? `${anterior.custoMensal}€/mês, dias: ${(anterior.dias || []).join(", ")}`
        : null,
      `${novoObjApt.custoMensal}€/mês, dias: ${(novoObjApt.dias || []).join(", ")}`
    );
    await setDoc(
      doc(db, "limpezas_config", "areas_comuns"),
      { [aptKey]: novoObjApt },
      { merge: true }
    );
  };
  const salvarLimpezasOcultasNaCloud = async (novoArray) => {
    const antigoSet = new Set(limpezasOcultas);
    const novoSet = new Set(novoArray);
    novoArray
      .filter((id) => !antigoSet.has(id))
      .forEach((id) =>
        registrarEdicaoNoHistorico("Visibilidade da Limpeza", id, "Visível", "Oculta")
      );
    limpezasOcultas
      .filter((id) => !novoSet.has(id))
      .forEach((id) =>
        registrarEdicaoNoHistorico("Visibilidade da Limpeza", id, "Oculta", "Visível")
      );
    await setDoc(doc(db, "limpezas_config", "limpezas_ocultas"), {
      ids: novoArray,
    });
  };

  const carregarDados = useCallback((isManualRefresh = false) => {
    if (isManualRefresh) setSincronizando(true);
    else setLoading(true);
    setErro(null);

    // Cada folha tem um limite de tempo próprio: uma ficando presa (já
    // aconteceu, sem nunca responder nem falhar) não pode voltar a travar a
    // app inteira para sempre — nesse caso, seguimos em frente sem os dados
    // dessa folha específica, em vez de ficar parados à espera dela.
    const TIMEOUT_POR_FOLHA_MS = 12000;

    const promises = ABAS.map((aba) => {
      const url = `${BASE_URL}&gid=${aba.gid}&t=${new Date().getTime()}`;
      const controller = new AbortController();
      const timeoutId = setTimeout(
        () => controller.abort(),
        TIMEOUT_POR_FOLHA_MS
      );
      return fetch(url, { signal: controller.signal })
        .then((res) => res.text())
        .then((text) => {
          clearTimeout(timeoutId);
          const rawRows = parseRobustCSV(text);
          let headerIndex = -1;
          for (let i = 0; i < rawRows.length; i++) {
            if (rawRows[i].join(" ").toLowerCase().includes("nome")) {
              headerIndex = i;
              break;
            }
          }
          if (headerIndex === -1) return [];
          const subHeaders = rawRows[headerIndex + 1] || [];
          let ultimoHeaderPai = "";
          const headers = rawRows[headerIndex].map((h, colIdx) => {
            const headerLimpo = h.replace(/[\r\n]+/g, " ").trim();
            if (headerLimpo) ultimoHeaderPai = headerLimpo;
            if (ultimoHeaderPai.toLowerCase().includes("primeira renda"))
              return `Primeira Renda ${
                (subHeaders[colIdx] || "").trim() || "Montante"
              }`;
            if (
              ultimoHeaderPai.toLowerCase().includes("depósito") &&
              colIdx > 17
            )
              return `Deposito ${
                (subHeaders[colIdx] || "").trim() || "Montante"
              }`;
            return headerLimpo || `Coluna_${colIdx}`;
          });

          const rows = [];
          for (let i = headerIndex + 1; i < rawRows.length; i++) {
            if (
              rawRows[i].length < 2 ||
              rawRows[i].join(" ").toLowerCase().includes("montante")
            )
              continue;
            const entry = {};
            headers.forEach((header, colIdx) => {
              if (header) entry[header] = rawRows[i][colIdx] || "";
            });
            entry["Observações"] = rawRows[i][rawRows[i].length - 1] || "";
            entry["_abaOrigem"] = aba.nome;
            rows.push(entry);
          }
          return rows;
        })
        .catch((err) => {
          clearTimeout(timeoutId);
          console.error(
            `Não foi possível carregar a folha ${aba.nome} (a seguir sem ela):`,
            err
          );
          return [];
        });
    });

    Promise.all(promises)
      .then((results) => {
        setDadosGlobais(results.flat());
        setUltimaAtualizacao(
          new Date().toLocaleTimeString("pt-PT", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          })
        );
        setLoading(false);
        setSincronizando(false);
      })
      .catch(() => {
        setErro("Erro na ligação.");
        setLoading(false);
        setSincronizando(false);
      });
  }, []);

  useEffect(() => {
    carregarDados(false);
  }, [carregarDados]);

  // Sincronização automática: a app volta a ler o Google Sheets sozinha de
  // tempos a tempos, e também quando a pessoa volta a esta aba depois de
  // estar noutra janela — para nunca depender de alguém lembrar-se de clicar
  // em "Sincronizar".
  useEffect(() => {
    const INTERVALO_SYNC_MS = 5 * 60 * 1000;
    const intervalo = setInterval(() => {
      carregarDados(true);
    }, INTERVALO_SYNC_MS);

    const handleVisibilidade = () => {
      if (document.visibilityState === "visible") {
        carregarDados(true);
      }
    };
    document.addEventListener("visibilitychange", handleVisibilidade);

    return () => {
      clearInterval(intervalo);
      document.removeEventListener("visibilitychange", handleVisibilidade);
    };
  }, [carregarDados]);

  // As tabelas em desktop (.tabela-desktop) por vezes são mais largas do
  // que o ecrã. A equipa não estava a conseguir fazer scroll horizontal
  // porque isso exige Shift+roda do rato ou um trackpad — com isto, a
  // roda normal do rato também desloca a tabela para os lados quando o
  // cursor está sobre ela e ainda há espaço para deslocar nessa direção;
  // caso contrário, a página continua a fazer scroll vertical normalmente.
  useEffect(() => {
    const handleWheel = (e) => {
      const scrollable = e.target.closest(".tabela-desktop");
      if (!scrollable) return;

      const maxScrollLeft = scrollable.scrollWidth - scrollable.clientWidth;
      if (maxScrollLeft <= 0) return;
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;

      const novoScrollLeft = scrollable.scrollLeft + e.deltaY;
      if (novoScrollLeft < 0 || novoScrollLeft > maxScrollLeft) return;

      scrollable.scrollLeft = novoScrollLeft;
      e.preventDefault();
    };

    document.addEventListener("wheel", handleWheel, { passive: false });
    return () => document.removeEventListener("wheel", handleWheel);
  }, []);

  const formatarDataJs = (strData) => {
    if (!strData) return null;
    let s = String(strData)
      .trim()
      .toLowerCase()
      .replace(/\s+00:00:00$/, "")
      .replace(".", "");
    if (!s || s === "-" || s === "n/a" || s === "nan") return null;
    const mesesPt = {
      jan: 0,
      fev: 1,
      mar: 2,
      abr: 3,
      mai: 4,
      jun: 5,
      jul: 6,
      ago: 7,
      set: 8,
      out: 9,
      nov: 10,
      dez: 11,
    };
    const partesTexto = s.split(/[-/\s]+/);
    if (partesTexto.length === 3 && mesesPt[partesTexto[1]] !== undefined)
      return new Date(
        parseInt(partesTexto[2], 10),
        mesesPt[partesTexto[1]],
        parseInt(partesTexto[0], 10)
      );
    if (s.includes("-") && s.split("-").length === 3)
      return new Date(
        parseInt(s.split("-")[0], 10),
        parseInt(s.split("-")[1], 10) - 1,
        parseInt(s.split("-")[2], 10)
      );
    if (s.includes("/") && s.split("/").length === 3)
      return new Date(
        parseInt(s.split("/")[2], 10),
        parseInt(s.split("/")[1], 10) - 1,
        parseInt(s.split("/")[0], 10)
      );
    return null;
  };

  const formatarDataLegivel = (dateObj, defaultVal = "-") => {
    if (!dateObj || isNaN(dateObj.getTime())) return defaultVal;
    return `${String(dateObj.getDate()).padStart(2, "0")} ${[
      "jan",
      "fev",
      "mar",
      "abr",
      "mai",
      "jun",
      "jul",
      "ago",
      "set",
      "out",
      "nov",
      "dez",
    ][dateObj.getMonth()].toLowerCase()}. ${dateObj.getFullYear()}`;
  };

  const estadiasEstruturadas = useMemo(() => {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const limiteDate = dataLimiteCheckin ? new Date(dataLimiteCheckin) : null;
    if (limiteDate) limiteDate.setHours(0, 0, 0, 0);

    return dadosGlobais
      .map((item, index) => {
        const aptVal =
          item["Apt"] || item["Apartamento"] || item["_abaOrigem"] || "N/A";
        const dEntradaContrato = formatarDataJs(
          item["Entrada Contrato"] || item["Entrada"]
        );
        const dSaidaContrato = formatarDataJs(
          item["Saída Contrato"] || item["Saída"]
        );
        // O S5# tem historicamente um erro de escrita no cabeçalho desta
        // coluna na folha de Google Sheets ("Comunidada" em vez de
        // "Comunicada") — aceitamos as duas grafias para não depender da
        // folha estar sempre bem escrita.
        const dEntradaComunicada = formatarDataJs(
          item["Entrada Comunicada"] || item["Entrada Comunidada"]
        );
        const dSaidaComunicada = formatarDataJs(item["Saída Comunicada"]);
        const dataEntradaEfetiva = dEntradaComunicada || dEntradaContrato;
        const dataSaidaEfetiva = dSaidaComunicada || dSaidaContrato;

        let estadoEstadia = "Desconhecido";
        if (dataEntradaEfetiva && dataSaidaEfetiva) {
          if (dataEntradaEfetiva > hoje) estadoEstadia = "Próximos";
          else if (dataEntradaEfetiva <= hoje && dataSaidaEfetiva >= hoje)
            estadoEstadia = "Atuais";
          else if (dataSaidaEfetiva < hoje) estadoEstadia = "Antigos";
        }

        return {
          id: index,
          apt: aptVal.trim(),
          quarto: item["Quarto"] || "-",
          nome: item["Nome"] || "",
          numeroInquilinos: item["Nº de Inquilinos"] || "",
          email: item["Email"] || item["Mail"] || "",
          contacto:
            item["Telemóvel"] || item["Contacto"] || item["Telefone"] || "-",
          plataforma: item["Plataforma"] || item["Canal"] || "",
          entradaContratoObj: dEntradaContrato,
          saidaContratoObj: dSaidaContrato,
          dataEntradaComunicadaObj: dEntradaComunicada,
          dataSaidaComunicadaObj: dSaidaComunicada,
          dataSaidaEfetivaObj: dataSaidaEfetiva,
          dataEntradaEfetivaObj: dataEntradaEfetiva,
          entradaContrato: formatarDataLegivel(
            dEntradaContrato,
            item["Entrada Contrato"] || item["Entrada"]
          ),
          saidaContrato: formatarDataLegivel(
            dSaidaContrato,
            item["Saída Contrato"] || item["Saída"]
          ),
          saidaComunicadaTexto: formatarDataLegivel(
            dSaidaComunicada,
            item["Saída Comunicada"]
          ),
          entradaEfetivaTexto: formatarDataLegivel(dataEntradaEfetiva),
          saidaEfetivaTexto: formatarDataLegivel(dataSaidaEfetiva),
          eta: item["ETA"] || "-",
          renda:
            parseFloat(
              String(item["Renda Mensal (com despesas)"] || "0")
                .replace(/[^0-9.,-]/g, "")
                .replace(",", ".")
            ) || 0,
          deposito:
            parseFloat(
              String(item["Deposito Montante"] || item["Depósito"] || "0")
                .replace(/[^0-9.,-]/g, "")
                .replace(",", ".")
            ) || 0,
          observacoes: item["Observações"] || "",
          estadoEstadia,
        };
      })
      .filter((item) => {
        const nomeValido =
          item.nome &&
          item.nome.trim() !== "" &&
          !["PRÓXIMOS", "ATUAIS", "DEVOLVER", "PEDIR", "ANTERIORES"].some((x) =>
            item.nome.toUpperCase().startsWith(x)
          );
        if (!nomeValido) return false;
        if (limiteDate && item.dataEntradaEfetivaObj)
          return item.dataEntradaEfetivaObj >= limiteDate;
        return true;
      });
  }, [dadosGlobais, dataLimiteCheckin]);

  const apartamentosUnicos = useMemo(
    () =>
      [
        "Todos",
        ...new Set(estadiasEstruturadas.map((item) => item.apt)),
      ].filter(Boolean),
    [estadiasEstruturadas]
  );

  if (loading || !firestoreConfigCarregado)
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#f8fafc",
        }}
      >
        <div className="spinner-coolivin" />
        <h3
          style={{
            fontFamily: "sans-serif",
            color: "#0f172a",
            fontWeight: "600",
            textAlign: "center",
            padding: "0 20px",
          }}
        >
          {mensagemCarregamento}
        </h3>
      </div>
    );

  return (
    <div
      style={{
        padding: "20px",
        fontFamily: "sans-serif",
        backgroundColor: "#f3f4f6",
        minHeight: "100vh",
      }}
    >
      <header
        style={{
          marginBottom: "20px",
          borderBottom: "1px solid #e5e7eb",
          paddingBottom: "15px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h1
          style={{
            margin: 0,
            fontSize: "24px",
            fontWeight: "bold",
            color: "#111827",
          }}
        >
          {isAdmin
            ? "Gestão de Alojamentos (Admin)"
            : "Escala de Limpezas Operacional"}
        </h1>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {ultimaAtualizacao && (
            <span style={{ fontSize: "12px", color: "#6b7280" }}>
              Sincronizado: <strong>{ultimaAtualizacao}</strong>
            </span>
          )}
          <button
            onClick={() => carregarDados(true)}
            disabled={sincronizando}
            style={{
              padding: "8px 14px",
              backgroundColor: sincronizando ? "#9ca3af" : "#2563eb",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            {sincronizando ? "A ler..." : "🔄 Sincronizar"}
          </button>
        </div>
      </header>

      {isAdmin && (
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginBottom: "20px",
            borderBottom: "2px solid #e5e7eb",
          }}
        >
          <button
            onClick={() => setAbaAtiva("gestao")}
            style={{
              padding: "10px 20px",
              border: "none",
              background: "none",
              fontSize: "15px",
              fontWeight: "bold",
              cursor: "pointer",
              borderBottom:
                abaAtiva === "gestao"
                  ? "3px solid #2563eb"
                  : "3px solid transparent",
              color: abaAtiva === "gestao" ? "#2563eb" : "#6b7280",
            }}
          >
            📊 Painel de Gestão Geral
          </button>
          <button
            onClick={() => setAbaAtiva("fluxo_movimentos")}
            style={{
              padding: "10px 20px",
              border: "none",
              background: "none",
              fontSize: "15px",
              fontWeight: "bold",
              cursor: "pointer",
              borderBottom:
                abaAtiva === "fluxo_movimentos"
                  ? "3px solid #06b6d4"
                  : "3px solid transparent",
              color: abaAtiva === "fluxo_movimentos" ? "#06b6d4" : "#6b7280",
            }}
          >
            🗓️ Checkins / Checkouts
          </button>
          <button
            onClick={() => setAbaAtiva("limpezas")}
            style={{
              padding: "10px 20px",
              border: "none",
              background: "none",
              fontSize: "15px",
              fontWeight: "bold",
              cursor: "pointer",
              borderBottom:
                abaAtiva === "limpezas"
                  ? "3px solid #db2777"
                  : "3px solid transparent",
              color: abaAtiva === "limpezas" ? "#db2777" : "#6b7280",
            }}
          >
            🧹 Escala de Limpeza
          </button>
          <button
            onClick={() => setAbaAtiva("historico")}
            style={{
              padding: "10px 20px",
              border: "none",
              background: "none",
              fontSize: "15px",
              fontWeight: "bold",
              cursor: "pointer",
              borderBottom:
                abaAtiva === "historico"
                  ? "3px solid #7c3aed"
                  : "3px solid transparent",
              color: abaAtiva === "historico" ? "#7c3aed" : "#6b7280",
            }}
          >
            📜 Histórico de Edições
          </button>
        </div>
      )}

      {abaAtiva === "gestao" && isAdmin && (
        <PainelGestao
          estadias={estadiasEstruturadas}
          apartamentosUnicos={apartamentosUnicos}
          dataLimiteCheckin={dataLimiteCheckin}
          onSalvarDataLimite={salvarDataLimiteNaCloud}
          onTipoQuartoChange={salvarTipoQuartoNaCloud}
          tipoQuartoDb={tipoQuarto}
          mensagemCarregamento={mensagemCarregamento}
          onSalvarMensagemCarregamento={salvarMensagemCarregamentoNaCloud}
        />
      )}

      {abaAtiva === "fluxo_movimentos" && isAdmin && (
        <PainelMovimentos estadias={estadiasEstruturadas} />
      )}

      {abaAtiva === "historico" && isAdmin && (
        <HistoricoEdicoes
          historico={historicoEdicoes}
          senhaCorreta={senhaHistorico}
        />
      )}

      {abaAtiva === "limpezas" && (
        <EscalaLimpeza
          estadias={estadiasEstruturadas}
          isAdmin={isAdmin}
          notasLimpeza={notasLimpeza}
          prioridades={prioridades}
          tipoCheckout={tipoCheckout}
          numInquilinos={numInquilinos}
          tipoQuarto={tipoQuarto}
          tipoPreparacao={tipoPreparacao}
          limpezasExtra={limpezasExtra}
          onNotaChange={salvarNotaNaCloud}
          onPrioridadeToggle={togglePrioridadeNaCloud}
          onTipoCheckoutChange={salvarTipoCheckoutNaCloud}
          onNumInquilinosChange={salvarNumInquilinosNaCloud}
          onTipoQuartoChange={salvarTipoQuartoNaCloud}
          onTipoPreparacaoChange={salvarTipoPreparacaoNaCloud}
          onAdicionarExtra={adicionarLimpezaExtraNaCloud}
          onRemoverExtra={removerLimpezaExtraNaCloud}
          reportsOlympus={reportsOlympus}
          onReportOlympusChange={salvarReportOlympusNaCloud}
          precosMatriz={precosMatriz}
          onPrecoMatrizChange={salvarPrecoMatrizNaCloud}
          configAreasComuns={configAreasComuns}
          onConfigAreaComumChange={salvarConfigAreaComumNaCloud}
          limpezasOcultas={limpezasOcultas}
          onLimpezasOcultasChange={salvarLimpezasOcultasNaCloud}
          onObservacaoInternaChange={salvarObservacaoInternaNaCloud}
          onDataFaturaChange={salvarDataFaturaNaCloud}
          onPrecoBaseManualChange={salvarPrecoBaseManualNaCloud}
          storage={storage}
          onCarregarReportsAntigos={carregarReportsAntigos}
          aCarregarReportsAntigos={aCarregarReportsAntigos}
          historicoAntigoCarregado={historicoAntigoCarregado}
        />
      )}
    </div>
  );
}
